import '../../sass/Contact/index.scss'
import {fadeAnimate} from '../components/fadeAnimate'
import {scrollToElementWithOffset} from '../components/scrollToElementWithOffset'

document.querySelectorAll('textarea.auto-size').forEach(function (textarea) {
    textarea.style.height = textarea.scrollHeight + 'px'
    textarea.style.overflowY = 'hidden'

    textarea.addEventListener('input', function () {
        this.style.height = 'auto'
        this.style.height = this.scrollHeight + 'px'
    })
})

document.addEventListener('submit', async function (e) {
    const form = e.target

    if (!form.classList.contains('js_contact_form')) return

    e.preventDefault()

    const url = form.getAttribute('action')
    const method = form.getAttribute('method').toUpperCase()
    const formData = new FormData(form)
    const data = new URLSearchParams(formData).toString()

    const success_message = form.querySelector('.js_contact_form_success')
    const error_message = form.querySelector('.js_contact_form_error')

    document.querySelectorAll('.js_contact_field').forEach(el => el.disabled = true)
    document.querySelectorAll('.js_contact_submit').forEach(el => el.disabled = true)

    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
                'X-Requested-With': 'xmlhttprequest',
            },
            body: data,
        })

        window.turnstile.reset()

        if (!response.ok) throw await response.json()

        const result = await response.json()

        error_message.style.display = 'none'

        success_message.innerHTML = result.message
        success_message.style.display = 'block'
        fadeAnimate(success_message)

        document.querySelectorAll('.js_contact_field').forEach(el => el.value = '')

        scrollToElementWithOffset(success_message)
    } catch (errorResponse) {
        window.turnstile.reset()

        success_message.style.display = 'none'

        error_message.innerHTML = errorResponse.message
        error_message.style.display = 'block'
        fadeAnimate(error_message)

        scrollToElementWithOffset(error_message)
    } finally {
        document.querySelectorAll('.js_contact_field').forEach(el => el.disabled = false)
        document.querySelectorAll('.js_contact_submit').forEach(el => el.disabled = false)
    }
})
